import { DocumentLines as o } from "./document-lines.js";
import { Reporting as m } from "./reporting.js";
import { DocumentStack as r } from "./document-stack.js";
import { Attachment as t } from "./attachment.js";
import { BookOpen as i } from "./book-open.js";
import { Certificate as e } from "./certificate.js";
import { Contract as p } from "./contract.js";
import { Document1 as f } from "./document-1.js";
import { DocumentCheckmark1 as n } from "./document-checkmark-1.js";
import { DocumentCheckmark2 as c } from "./document-checkmark-2.js";
import { DocumentMinus as u } from "./document-minus.js";
import { DocumentPerson as a } from "./document-person.js";
import { DocumentPlus as D } from "./document-plus.js";
import { Folder as k } from "./folder.js";
import { FolderFill as l } from "./folder-fill.js";
import { Image as s } from "./image.js";
import { LetterT as C } from "./letter-t.js";
import { Library as F } from "./library.js";
const v = {
  DocumentLines: o,
  Reporting: m,
  DocumentStack: r,
  Attachment: t,
  BookOpen: i,
  Certificate: e,
  Contract: p,
  Document1: f,
  DocumentCheckmark1: n,
  DocumentCheckmark2: c,
  DocumentMinus: u,
  DocumentPerson: a,
  DocumentPlus: D,
  Folder: k,
  FolderFill: l,
  Image: s,
  LetterT: C,
  Library: F
};
export {
  v as Files
};
